export const SEO_GAME_DETAILS = {
  "figuru-rusiavimas": {
    intro: "Interaktyvus žaidimas, kuriame vaikas rūšiuoja ir atpažįsta skirtingas geometrines figūras.",
    mechanics: "Vaikas turi atpažinti figūrą ir priskirti ją tinkamai vietai. Už teisingus pasirinkimus skiriami taškai.",
    howToPlay: "Peržiūrėk pateiktas figūras, atpažink jų formą ir nutempk arba pasirink figūrą tinkamoje vietoje.",
    benefits: [
      "lavina formų atpažinimą",
      "stiprina loginį mąstymą",
      "lavina dėmesį ir vizualinį suvokimą"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams"
  },

  "spalvu-derinimas": {
    intro: "Žaidimas, kuriame vaikas mokosi atpažinti ir susieti skirtingas spalvas.",
    mechanics: "Vaikas rūšiuoja pateiktus objektus pagal jų spalvas ir tikrina savo pasirinkimus.",
    howToPlay: "Peržiūrėk objektus ir priskirk kiekvieną jų tinkamai spalvai.",
    benefits: [
      "lavina spalvų atpažinimą",
      "stiprina dėmesį",
      "lavina rūšiavimo įgūdžius"
    ],
    suitableFor: "ikimokyklinio amžiaus vaikams"
  },

  "skaiciu-atitikimas": {
    intro: "Skaičių atitikimas – matematikos žaidimas, padedantis vaikui susieti skaičių su atitinkamu kiekiu. Vaikas mokosi suprasti, kad skaitmuo žymi konkretų objektų ar elementų skaičių. Tokia praktika sudaro svarbų pagrindą ankstyvajam skaičiavimui ir skaičių suvokimui.",
    mechanics: "Žaidime pateikiamas skaičius ir keli objektų arba kiekių variantai. Vaikas turi atpažinti skaičių ir pasirinkti tokį kiekį, kuris jam atitinka. Kartojant skirtingas reikšmes stiprinamas ryšys tarp skaitmens, skaičiavimo ir realiai matomo kiekio.",
    howToPlay: "Atpažink pateiktą skaičių ir suskaičiuok objektus kiekviename pasirinkime. Palygink gautą kiekį su pateiktu skaičiumi ir pasirink atitinkantį variantą. Jei reikia, perskaičiuok objektus dar kartą prieš patvirtindamas atsakymą.",
    benefits: [
      "lavina skaičių pažinimą",
      "stiprina skaičiavimo įgūdžius",
      "padeda suprasti skaičiaus ir kiekio ryšį"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams, besimokantiems skaičių ir kiekių"
  },

  "zodziu-sudarymas": {
    intro: "Žodžių Sudarymas – lietuvių kalbos žaidimas, kuriame vaikas iš pateiktų raidžių sudaro žodžius. Užduotis padeda susieti atskiras raides su visu žodžiu, lavina raidžių pažinimą ir skatina geriau suprasti žodžio struktūrą. Žaidybinis formatas leidžia praktiškai kartoti žodžių sudarymą.",
    mechanics: "Žaidime pateikiamas žodis ir sumaišytos jo raidės. Vaikas turi jas atpažinti ir sudėlioti tinkama tvarka, kad susidarytų teisingas žodis. Spręsdamas užduotį jis analizuoja raidžių seką, tikrina žodžio reikšmę ir mokosi pastebėti, kaip atskiros raidės sudaro visą žodį.",
    howToPlay: "Peržiūrėk visas pateiktas raides ir pagalvok, kokį žodį iš jų galima sudaryti. Sudėliok raides tinkama tvarka ir perskaityk gautą žodį. Patikrink, ar jis yra prasmingas ir ar panaudotos visos reikalingos raidės. Jei atsakymas netinka, pakeisk raidžių tvarką ir bandyk dar kartą.",
    benefits: [
      "lavina žodyną",
      "stiprina raidžių pažinimą",
      "lavina žodžio struktūros suvokimą"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams, besimokantiems sudaryti žodžius"
  },

  "sekos-kurimas": {
    intro: "Sekos kūrimas – matematikos ir loginio mąstymo žaidimas, kuriame vaikas mokosi atpažinti dėsningumus ir sudaryti nuoseklias sekas. Analizuodamas skaičius ar kitus pateiktus elementus vaikas ieško pasikartojančios taisyklės ir pagal ją nustato, kas turi būti toliau. Tai lavina loginį mąstymą, dėmesį ir gebėjimą pastebėti struktūrą.",
    mechanics: "Žaidime pateikiama seka, kurioje elementai išdėstyti pagal tam tikrą dėsningumą. Vaikas turi išanalizuoti pateiktą tvarką ir nustatyti, kokia taisyklė ją sieja. Pagal atrastą dėsningumą reikia pasirinkti arba sudaryti tinkamą sekos tęsinį.",
    howToPlay: "Peržiūrėk visus sekos elementus ir ieškok pasikartojančio principo. Patikrink, kaip keičiasi skaičiai, formos ar kiti elementai nuo vieno žingsnio iki kito. Nustatęs taisyklę pasirink tai, kas logiškai turėtų sekti toliau. Prieš patvirtindamas patikrink, ar tavo taisyklė tinka visai pateiktai sekai.",
    benefits: [
      "lavina loginį mąstymą",
      "moko pastebėti dėsningumus",
      "stiprina problemų sprendimo įgūdžius"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, lavinantiems dėsningumų atpažinimą ir loginį mąstymą"
  },

  "sablonu-derinimas": {
    intro: "Atminties ir loginio mąstymo žaidimas, kuriame reikia įsiminti ir atkurti pateiktą šabloną.",
    mechanics: "Šablonas trumpam parodomas vaikui, o vėliau elementai pateikiami sumaišyti.",
    howToPlay: "Atidžiai įsimink šabloną, o jam pasislėpus pasirink elementus tokia pačia tvarka.",
    benefits: [
      "lavina darbinę atmintį",
      "stiprina dėmesį",
      "lavina sekų suvokimą"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams"
  },

  "pasakojimo-seka": {
    intro: "Pasakojimo seka – skaitymo ir loginio mąstymo žaidimas, padedantis vaikui suprasti įvykių eigą ir sudėlioti pasakojimą nuoseklia tvarka. Vaikas mokosi atpažinti, kas įvyko pirmiausia, kas vėliau ir kuo istorija baigėsi. Tai padeda stiprinti teksto supratimą bei priežasties ir pasekmės ryšių suvokimą.",
    mechanics: "Žaidime pateikiami sumaišyti pasakojimo sakiniai arba įvykių dalys. Vaikas turi išanalizuoti jų prasmę, nustatyti tarpusavio ryšius ir sudėlioti logišką seką. Spręsdamas užduotį jis remiasi teksto informacija ir įvykių chronologija.",
    howToPlay: "Perskaityk visus pateiktus sakinius arba įvykius. Nustatyk, kuris įvykis galėjo nutikti pirmiausia, o tada ieškok jo tęsinio. Sudėliok visą pasakojimą nuo pradžios iki pabaigos ir dar kartą perskaityk seką, kad patikrintum jos logiką.",
    benefits: [
      "lavina teksto supratimą",
      "stiprina loginį mąstymą",
      "moko suvokti pasakojimo struktūrą"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, lavinantiems skaitymo supratimą ir loginį nuoseklumą"
  },

  "matematines-lygtys": {
    intro: "Matematinės lygtys – matematikos žaidimas, kuriame vaikas mokosi suprasti lygybę ir rasti nežinomą skaičių paprastose lygtyse. Spręsdamas užduotis vaikas lavina skaičiavimo įgūdžius ir mokosi ieškoti ryšio tarp žinomų bei nežinomų reikšmių. Žaidybinis formatas leidžia kartoti matematinius veiksmus praktiškai.",
    mechanics: "Žaidime pateikiamos paprastos matematinės lygtys, kuriose trūksta vieno skaičiaus arba reikia nustatyti tinkamą rezultatą. Vaikas analizuoja žinomus skaičius ir veiksmą, tada ieško reikšmės, kuri užtikrina teisingą lygybę. Užduotys skatina ne tik skaičiuoti, bet ir suprasti lygties struktūrą.",
    howToPlay: "Perskaityk lygtį ir nustatyk, kurio skaičiaus trūksta. Apskaičiuok galimą reikšmę ir patikrink, ar įrašius ją abi lygties pusės tampa lygios. Jei reikia, išbandyk kitą skaičių ir dar kartą patikrink rezultatą.",
    benefits: [
      "lavina skaičiavimo įgūdžius",
      "stiprina matematinių veiksmų supratimą",
      "lavina loginį mąstymą"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems spręsti paprastas matematines lygtis"
  },

  "sokinejimas-ant-skaiciu-tieses": {
    intro: "Šokinėjimas ant skaičių tiesės – matematikos žaidimas, padedantis vaikui suprasti skaičių seką ir sudėties bei atimties veiksmus naudojant skaičių tiesę. Vaikas mokosi matyti, kaip judėjimas į priekį ar atgal keičia skaičiaus reikšmę. Vizualus būdas padeda abstrakčius skaičiavimus susieti su konkrečiu veiksmu.",
    mechanics: "Žaidime vaikas juda skaičių tiesėje pagal pateiktą matematinę užduotį. Šuolis į priekį gali parodyti didėjimą arba sudėtį, o judėjimas atgal – mažėjimą arba atimtį. Taip vaikas praktiškai mokosi orientuotis skaičių sekoje ir suprasti veiksmų rezultatą.",
    howToPlay: "Perskaityk pateiktą veiksmą ir surask pradinį skaičių skaičių tiesėje. Pagal užduotį judėk reikiamą žingsnių skaičių į priekį arba atgal. Sustojęs patikrink, ant kurio skaičiaus atsidūrei, ir pasirink jį kaip atsakymą.",
    benefits: [
      "padeda suprasti skaičių tiesę",
      "lavina skaičiavimą",
      "stiprina skaičių sekos suvokimą"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems sudėties, atimties ir skaičių sekos"
  },

  "trupmenos-su-pica": {
    intro: "Trupmenos su Pica – vizualus matematikos žaidimas, kuriame trupmenų sąvoka aiškinama per vaikui lengvai suprantamą picos pavyzdį. Vaikas mato visumą, jos dalis ir mokosi susieti paveikslėlyje matomą dalį su trupmenos užrašu. Toks praktinis kontekstas padeda geriau suprasti, ką reiškia skaitiklis, vardiklis ir visumos padalijimas į lygias dalis.",
    mechanics: "Žaidime pica padalijama į skirtingą skaičių lygių dalių, o vaikas turi nustatyti, kokią visumos dalį sudaro pasirinkti gabalėliai. Užduotys lavina gebėjimą matyti ryšį tarp konkretaus objekto ir matematinio trupmenos užrašo. Vaikas mokosi atpažinti trupmenas ne tik skaičiais, bet ir vaizdiniu būdu.",
    howToPlay: "Peržiūrėk, į kiek lygių dalių padalinta pica ir kiek jų pasirinkta. Pirmiausia nustatyk, kiek dalių sudaro visą picą, tada suskaičiuok pasirinktas dalis. Pagal šią informaciją pasirink arba įrašyk tinkamą trupmeną.",
    benefits: [
      "padeda suprasti trupmenas",
      "lavina dalies ir visumos suvokimą",
      "matematiką susieja su praktiniu pavyzdžiu"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems trupmenų pagrindų"
  },

  "matematikos-bingo": {
    intro: "Matematikos Bingo – žaismingas matematikos žaidimas, kuriame vaikas kartoja skaičiavimo veiksmus ieškodamas teisingų atsakymų bingo lentoje. Žaidimo formatas leidžia daug kartų praktikuoti matematinius veiksmus ir kartu išlaikyti dėmesį. Vaikas mokosi greitai susieti užduotį su tinkama skaitine reikšme.",
    mechanics: "Žaidime pateikiama matematinė užduotis ir bingo lentoje reikia rasti ją atitinkantį atsakymą. Vaikas analizuoja veiksmą, apskaičiuoja rezultatą ir pažymi tinkamą langelį. Kartojant skirtingas užduotis lavinamas skaičiavimo tikslumas bei gebėjimas greitai atpažinti rezultatą.",
    howToPlay: "Išspręsk pateiktą matematikos užduotį ir įsidėmėk gautą rezultatą. Tada surask tokį skaičių bingo lentoje ir pasirink jį. Kartok užduotis, kol pagal žaidimo taisykles užpildysi reikiamą langelių seką.",
    benefits: [
      "lavina skaičiavimą",
      "stiprina matematinį tikslumą",
      "lavina dėmesį"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, norintiems žaismingai kartoti matematikos veiksmus"
  },

  "pinigine-parduotuve": {
    intro: "Pinigų Parduotuvė – praktinės matematikos žaidimas, kuriame vaikas mokosi skaičiuoti pinigus per kasdienę apsipirkimo situaciją. Užduotys padeda suprasti prekių kainas, apskaičiuoti bendrą sumą ir įvertinti, kiek pinigų reikia pirkiniui. Mokymasis susiejamas su realaus gyvenimo situacija, todėl matematiniai veiksmai tampa lengviau suprantami.",
    mechanics: "Vaikas analizuoja prekių kainas, sudeda jų vertes, apskaičiuoja reikalingą sumą ir sprendžia su pirkimu susijusias užduotis. Žaidimas gali lavinti sudėtį, atimtį ir praktinį pinigų skaičiavimą. Skirtingos situacijos leidžia vaikui mokytis priimti sprendimą pagal pateiktą biudžetą ar pirkinių sąrašą.",
    howToPlay: "Peržiūrėk prekių kainas ir išsiaiškink, ką reikia nupirkti. Apskaičiuok bendrą pirkinių kainą arba patikrink, kiek pinigų liktų po pirkimo. Tada pasirink atsakymą, kuris tiksliausiai atitinka pateiktą apsipirkimo situaciją.",
    benefits: [
      "lavina pinigų pažinimą",
      "stiprina skaičiavimo įgūdžius",
      "moko matematiką taikyti kasdienėse situacijose"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems praktiškai taikyti matematiką ir skaičiuoti pinigus"
  },

  "laikrodzio-meistras": {
    intro: "Laikrodžio Meistras – žaismingas matematikos žaidimas, padedantis vaikui suprasti laiką, pažinti laikrodžio rodykles ir susieti valandas bei minutes su konkrečiu paros metu. Atlikdamas praktines užduotis vaikas mokosi ne tik perskaityti analoginio laikrodžio rodmenis, bet ir geriau suprasti, kaip laikas matuojamas kasdienybėje.",
    mechanics: "Žaidime vaikas analizuoja valandų ir minučių rodyklių padėtį, nustato rodomą laiką ir pasirenka arba nustato tinkamą laikrodžio rodmenį. Užduotys leidžia praktiškai kartoti valandų, pusvalandžių ir minučių sąvokas bei lavinti gebėjimą tiksliai interpretuoti analoginį laikrodį.",
    howToPlay: "Stebėk laikrodžio rodykles ir pirmiausia nustatyk valandą, o tada įvertink minučių rodyklės padėtį. Pasirink teisingą atsakymą arba nustatyk laikrodyje prašomą laiką. Sudėtingesnėse užduotyse patikrink, ar tavo pasirinktas laikas atitinka pateiktą situaciją.",
    benefits: [
      "moko pažinti analoginį laikrodį",
      "stiprina laiko suvokimą",
      "lavina dėmesį"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems pažinti laikrodį, valandas ir minutes"
  },

  "geometrijos-statytojas": {
    intro: "Geometrijos Statytojas – matematikos žaidimas, padedantis vaikui pažinti geometrines figūras ir suprasti pagrindines jų savybes. Atlikdamas praktines konstravimo užduotis vaikas mokosi atpažinti figūrų formas, dydžius ir tarpusavio ryšius. Vizualus mokymosi būdas leidžia geometrijos sąvokas susieti su konkrečiais objektais.",
    mechanics: "Žaidime vaikas dirba su geometrinėmis figūromis ir turi jas atpažinti, pasirinkti arba panaudoti kuriant pateiktą objektą. Užduotys skatina pastebėti figūros formą ir tinkamai ją pritaikyti pagal sąlygą. Taip matematinės sąvokos mokomos per veiksmą, o ne vien per teorinį apibrėžimą.",
    howToPlay: "Peržiūrėk pateiktą užduotį ir atpažink reikalingas geometrines figūras. Pasirink tinkamą formą arba panaudok ją nurodytoje vietoje. Prieš patvirtindamas atsakymą patikrink, ar pasirinktos figūros atitinka užduotyje nurodytą formą ir paskirtį.",
    benefits: [
      "lavina geometrinį mąstymą",
      "stiprina figūrų pažinimą",
      "lavina erdvinį suvokimą"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems geometrinių figūrų"
  },

  "grafiku-kurejas": {
    intro: "Grafikų Kūrėjas – matematikos žaidimas, padedantis vaikui suprasti duomenų pateikimą grafikais ir mokytis juos interpretuoti. Vaikas analizuoja kiekius, lygina duomenis ir mokosi pavaizduoti informaciją suprantamu būdu. Tokios užduotys ugdo ne tik skaičiavimo, bet ir duomenų skaitymo įgūdžius.",
    mechanics: "Žaidime pateikiami skaičiai, objektų kiekiai arba paprastos duomenų grupės, kurias reikia išanalizuoti ir pavaizduoti grafike. Vaikas mokosi susieti konkretų kiekį su grafiko stulpeliu ar kitu vaizdiniu elementu. Lygindamas skirtingus duomenis jis gali nustatyti, kuris kiekis didesnis, mažesnis arba vienodas.",
    howToPlay: "Pirmiausia peržiūrėk pateiktus duomenis ir suskaičiuok arba nustatyk jų kiekius. Tada pasirink tinkamą grafiko reikšmę arba sudėliok duomenis pagal užduoties sąlygą. Galiausiai patikrink grafiką ir palygink jame pavaizduotus kiekius.",
    benefits: [
      "lavina duomenų supratimą",
      "moko skaityti grafikus",
      "stiprina loginį mąstymą"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems skaityti ir sudaryti paprastus grafikus"
  },

  "daugybos-lenktynes": {
    intro: "Daugybos Lenktynės – greitas matematikos žaidimas, skirtas daugybos lentelei kartoti ir skaičiavimo įgūdžiams stiprinti. Vaikas sprendžia daugybos užduotis, mokosi greičiau atpažinti rezultatus ir kartu treniruoja matematinį tikslumą. Žaidybinis tempas padeda daugybos veiksmus kartoti daug kartų neperkraunant mokymosi vien teorija.",
    mechanics: "Žaidime pateikiamos daugybos užduotys, o vaikas turi kuo tiksliau ir greičiau nustatyti teisingą rezultatą. Už teisingus atsakymus renkami taškai, todėl vaikas gali lavinti tiek daugybos lentelės žinias, tiek skaičiavimo greitį. Užduočių sudėtingumas gali būti pritaikomas pagal mokymosi lygį.",
    howToPlay: "Perskaityk pateiktą daugybos veiksmą, apskaičiuok rezultatą ir pasirink teisingą atsakymą. Jei abejoji, pirmiausia prisimink atitinkamą daugybos lentelės eilutę. Žaisdamas kelis raundus stenkis ne tik atsakyti greitai, bet ir išlaikyti tikslumą.",
    benefits: [
      "lavina daugybos lentelės įgūdžius",
      "gerina skaičiavimo greitį",
      "stiprina matematinį pasitikėjimą"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems ir kartojantiems daugybos lentelę"
  },

  "abeceles-nuotykis": {
    intro: "Abėcėlės Nuotykis – žaismingas lietuvių kalbos ir skaitymo žaidimas, padedantis vaikui pažinti raides, įsiminti jų pavadinimus ir suprasti abėcėlės tvarką. Užduotys skirtos raidžių atpažinimui ir orientavimuisi tarp skirtingų abėcėlės simbolių. Žaidybinės užduotys leidžia kartoti raides aktyviai, o ne vien mokantis jas iš atminties.",
    mechanics: "Vaikas atlieka užduotis, kuriose reikia atpažinti raides, rasti konkrečią raidę arba nustatyti jos vietą abėcėlėje. Žaidimo mechanika lavina vizualinį raidžių atpažinimą ir padeda susieti atskiras raides su jų seka. Tai svarbus pagrindas ankstyvajam skaitymui ir žodžių sudarymui.",
    howToPlay: "Atpažink pateiktą raidę ir atkreipk dėmesį į jos vietą lietuvių abėcėlėje. Priklausomai nuo užduoties, pasirink tinkamą raidę, sudėliok simbolius reikiama tvarka arba surask prašomą abėcėlės elementą. Stenkis įsiminti ne tik raidės formą, bet ir jos vietą sekoje.",
    benefits: [
      "stiprina raidžių pažinimą",
      "padeda mokytis abėcėlės",
      "lavina dėmesį"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams, besimokantiems raidžių ir abėcėlės"
  },

  "skiemenu-rusiuotojas": {
    intro: "Skiemenų Rūšiuotojas – lietuvių kalbos ir skaitymo žaidimas, kuriame vaikas mokosi atpažinti skiemenis ir suprasti žodžių struktūrą. Žodžių skaidymas į skiemenis padeda stiprinti ankstyvojo skaitymo įgūdžius, geriau pastebėti žodžio dalis ir pasiruošti sklandesniam žodžių perskaitymui. Užduotys pateikiamos praktiškai ir žaismingai.",
    mechanics: "Vaikas analizuoja pateiktus žodžius, atpažįsta jų skiemenis ir atlieka rūšiavimo arba skaidymo užduotis. Žaidimas padeda pastebėti, kad žodis susideda iš atskirų skiemenų, kuriuos galima atpažinti ir susieti su tarimu. Kartojant skirtingus žodžius lavinamas kalbinis sąmoningumas ir skaitymo tikslumas.",
    howToPlay: "Perskaityk pateiktą žodį ir ištark jį lėtai. Atkreipk dėmesį į girdimus skiemenis, tada suskirstyk žodį į tinkamas dalis arba pasirink teisingą jų variantą. Patikrink, ar tavo pasirinkimas atitinka visą žodį ir jo tarimą.",
    benefits: [
      "lavina skiemenų atpažinimą",
      "stiprina fonologinį suvokimą",
      "padeda suprasti žodžio struktūrą"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams, besimokantiems skiemenuoti ir skaityti"
  },

  "rimu-laikas": {
    intro: "Rimų Laikas – lietuvių kalbos žaidimas, kuriame vaikas mokosi atpažinti ir kurti rimuojamus žodžius. Lygindamas skirtingų žodžių skambesį vaikas pastebi jų panašumus ir mokosi atkreipti dėmesį į žodžių galūnes bei garsinę struktūrą. Žaismingos užduotys padeda kartu plėsti žodyną ir lavinti kalbinį sąmoningumą.",
    mechanics: "Žaidime pateikiami žodžiai, kuriuos vaikas turi palyginti ir nustatyti, kurie iš jų rimuojasi. Užduotys skatina klausytis žodžių skambesio, pastebėti pasikartojančius garsų junginius ir susieti panašiai skambančius žodžius. Kartojant skirtingus pavyzdžius stiprinamas gebėjimas atpažinti rimą.",
    howToPlay: "Perskaityk arba ištark pateiktą žodį ir atidžiai įsiklausyk į jo skambesį. Palygink jį su kitais pateiktais žodžiais ir pasirink tuos, kurie rimuojasi. Jei užduotis prašo sukurti rimą, pagalvok apie žodį, kurio skambesys būtų panašus. Patikrink savo pasirinkimą dar kartą prieš patvirtindamas atsakymą.",
    benefits: [
      "lavina fonologinį suvokimą",
      "plečia žodyną",
      "stiprina kalbinę klausą"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams, lavinantiems rimą ir žodyną"
  },

  "sakiniu-sudarymas": {
    intro: "Sakinių Sudarymas – lietuvių kalbos žaidimas, padedantis vaikui mokytis sudaryti taisyklingus sakinius iš pateiktų žodžių. Vaikas praktikuoja žodžių tvarką, sakinio prasmę ir kalbos struktūrą. Tokios užduotys padeda pereiti nuo pavienių žodžių prie rišlesnio minčių reiškimo.",
    mechanics: "Žaidime pateikiami žodžiai arba jų grupės, kurias reikia sudėlioti logiška ir gramatiškai tinkama tvarka. Vaikas analizuoja kiekvieno žodžio vietą ir tikrina, ar sudarytas sakinys turi aiškią prasmę. Kartojant skirtingus pavyzdžius lavinamas kalbos struktūros suvokimas.",
    howToPlay: "Perskaityk visus pateiktus žodžius ir pagalvok, kokią mintį jie turi išreikšti. Sudėliok žodžius taip, kad susidarytų taisyklingas sakinys. Perskaityk gautą sakinį dar kartą ir patikrink jo prasmę bei žodžių tvarką.",
    benefits: [
      "lavina sakinio struktūros supratimą",
      "stiprina kalbos įgūdžius",
      "moko taisyklingos žodžių tvarkos"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems sudaryti taisyklingus sakinius"
  },

  "balses-vs-priebalses": {
    intro: "Balsės vs Priebalsės – lietuvių kalbos žaidimas, padedantis vaikui atskirti balses nuo priebalsių ir geriau suprasti lietuvių kalbos raidžių sandarą. Užduotys skatina atidžiai pažvelgti į kiekvieną raidę ir nustatyti, kuriai grupei ji priklauso. Tai naudinga mokantis skaityti, rašyti ir analizuoti žodžių struktūrą.",
    mechanics: "Žaidime pateikiamos skirtingos lietuvių kalbos raidės, o vaikas turi nustatyti, ar konkreti raidė yra balsė, ar priebalsė. Kartojant įvairias raides formuojamas greitesnis jų atpažinimas ir stiprinamas supratimas apie žodžių garsinę bei rašytinę struktūrą.",
    howToPlay: "Peržiūrėk pateiktą raidę ir ištark ją mintyse arba garsiai. Pagal jos pobūdį pasirink, ar tai balsė, ar priebalsė. Jei kyla abejonių, prisimink išmoktą balsių grupę ir palygink raidę su kitais žinomais pavyzdžiais.",
    benefits: [
      "moko skirti balses ir priebalses",
      "stiprina fonologinį suvokimą",
      "lavina raidžių pažinimą"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems atskirti balses ir priebalses"
  },

  "pasakos-sudeliojimas": {
    intro: "Žaidimas, kuriame vaikas atkuria pasakos eigą sudėliodamas jos dalis tinkama tvarka.",
    mechanics: "Pasakojimo dalys pateikiamos sumaišytos, todėl vaikas turi nustatyti loginę įvykių seką.",
    howToPlay: "Perskaityk visas pasakos dalis ir sudėliok jas nuo pradžios iki pabaigos.",
    benefits: [
      "lavina teksto supratimą",
      "stiprina loginį mąstymą",
      "moko suvokti pasakojimo struktūrą"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams"
  },

  "zodziu-seimos-medis": {
    intro: "Žodžių Šeimos Medis – lietuvių kalbos žaidimas, padedantis vaikui suprasti tarpusavyje susijusius žodžius ir jų šeimas. Vaikas analizuoja žodžius, ieško bendrų dalių ir mokosi pastebėti jų tarpusavio ryšius. Tokia veikla plečia žodyną ir padeda geriau suprasti, kaip žodžiai gali būti susiję pagal savo sandarą ir reikšmę.",
    mechanics: "Žaidime pateikiami žodžiai, kuriuos reikia susieti į žodžių šeimas. Vaikas analizuoja jų panašumus ir ieško žodžių, priklausančių tai pačiai grupei. Sudarydamas žodžių šeimas jis mokosi pastebėti bendras žodžių dalis ir geriau suprasti jų ryšius.",
    howToPlay: "Peržiūrėk visus pateiktus žodžius ir ieškok tų, kurie turi bendrą dalį arba yra tarpusavyje susiję. Sugrupuok priklausančius žodžius į vieną šeimą. Jei kyla abejonių, palygink žodžių sandarą ir reikšmę. Baigęs dar kartą patikrink, ar kiekvienas žodis priskirtas tinkamai šeimai.",
    benefits: [
      "plečia žodyną",
      "lavina žodžių ryšių suvokimą",
      "stiprina kalbos struktūros supratimą"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, plečiantiems žodyną ir mokantis žodžių ryšių"
  },

  "didziuju-raidziu-detektyvas": {
    intro: "Didžiųjų Raidžių Detektyvas – lietuvių kalbos ir rašybos žaidimas, kuriame vaikas mokosi pastebėti vietas, kur reikia vartoti didžiąją raidę. Analizuodamas žodžius ir sakinius vaikas praktiškai kartoja svarbias rašybos taisykles. Detektyvinis formatas skatina atidžiai skaityti ir ieškoti konkrečių kalbos klaidų.",
    mechanics: "Žaidime pateikiamas tekstas, kuriame reikia nustatyti, kuriuose žodžiuose ar sakinio vietose turi būti naudojama didžioji raidė. Vaikas analizuoja kontekstą ir sprendžia, ar pateiktas variantas atitinka rašybos taisyklę. Taip praktikuojamas didžiųjų raidžių vartojimas realiame sakinyje, o ne tik atskirame žodyje.",
    howToPlay: "Perskaityk pateiktą sakinį arba tekstą ir atkreipk dėmesį į žodžius, kurių rašyba gali būti netaisyklinga. Nustatyk, kur reikia didžiosios raidės, ir pasirink arba pataisyk tinkamą variantą. Baigęs dar kartą perskaityk visą sakinį ir patikrink, ar didžiosios raidės pavartotos pagal prasmę ir rašybos taisykles.",
    benefits: [
      "lavina rašybos įgūdžius",
      "moko didžiųjų raidžių vartojimo",
      "stiprina teksto analizę"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems lietuvių kalbos rašybos"
  },

  "garsu-safari": {
    intro: "Garsų Safari – kalbinis ir logopedinis žaidimas, kuriame vaikas mokosi atpažinti ir skirti skirtingus kalbos garsus. Žaismingas gyvūnų ir safari kontekstas padeda sutelkti dėmesį į garsinę informaciją ir kartoti užduotis natūraliai. Veikla gali būti naudinga lavinant foneminį suvokimą bei garsų atpažinimą.",
    mechanics: "Žaidime vaikas susiduria su skirtingais kalbos garsais ir turi juos atpažinti arba susieti su pateiktu variantu. Užduotys skatina klausytis, palyginti garsus ir nustatyti jų skirtumus. Kartojant skirtingus pavyzdžius stiprinamas gebėjimas sąmoningai atkreipti dėmesį į kalbos garsinę struktūrą.",
    howToPlay: "Atidžiai išklausyk arba perskaityk pateiktą užduotį ir sutelk dėmesį į konkretų garsą. Palygink galimus variantus ir pasirink tą, kuris atitinka užduoties sąlygą. Kartodamas užduotis stenkis pastebėti, kuo panašūs ir kuo skiriasi skirtingi kalbos garsai.",
    benefits: [
      "lavina garsų atpažinimą",
      "stiprina klausos dėmesį",
      "lavina fonologinį suvokimą"
    ],
    suitableFor: "vaikams, lavinantiems kalbos garsų atpažinimą ir foneminį suvokimą"
  },

  "zodziu-lauzykliu-issukis": {
    intro: "Žodžių Laužiklių Iššūkis – kalbinis žaidimas, kuriame vaikas žaismingai praktikuoja sudėtingesnių žodžių ir garsų tarimą. Kartojant panašiai skambančius žodžius lavinamas dėmesys kalbos garsams, tarimo tikslumas ir gebėjimas išlaikyti teisingą žodžių seką. Iššūkio formatas skatina kartoti užduotis ir gerinti rezultatą.",
    mechanics: "Žaidime pateikiamos žodžių arba garsų sekos, kurias reikia perskaityti, pakartoti arba atpažinti pagal užduoties sąlygą. Panašūs garsai reikalauja didesnio tikslumo, todėl vaikas turi išlaikyti dėmesį visos sekos metu. Kartojimas padeda pastebėti sudėtingesnes vietas ir lavinti kalbinį tikslumą.",
    howToPlay: "Pirmiausia lėtai perskaityk arba išanalizuok pateiktą žodžių seką. Stenkis tarti kiekvieną žodį aiškiai ir išlaikyti teisingą jų tvarką. Pakartok užduotį dar kartą, jei nori pagerinti tikslumą ir lengviau įveikti sudėtingiausias žodžių kombinacijas.",
    benefits: [
      "lavina kalbos raišką",
      "stiprina tarimo praktiką",
      "lavina kalbinį dėmesį"
    ],
    suitableFor: "vaikams, norintiems žaismingai lavinti kalbos garsų atpažinimą, tarimą ir kalbinį dėmesį"
  },

  "minimaliu-poru-atmintis": {
    intro: "Minimalių Porų Atmintis – logopedinis žaidimas, skirtas panašiai skambančių kalbos garsų ir žodžių skyrimui. Vaikas mokosi pastebėti nedidelius garsinius skirtumus tarp minimalių porų, pavyzdžiui, žodžių, kurie skiriasi vienu garsu. Tokia veikla gali padėti lavinti foneminį suvokimą ir atidesnį kalbos garsų klausymą.",
    mechanics: "Žaidime vaikas dirba su minimaliomis garsų poromis ir turi atpažinti, kuo pateikti žodžiai ar garsai skiriasi. Užduotys reikalauja klausytis, lyginti ir įsiminti garsinę informaciją. Žaidybinis kartojimas padeda treniruoti gebėjimą pastebėti nedidelius tarimo skirtumus.",
    howToPlay: "Atidžiai klausykis arba perskaityk pateiktas žodžių poras. Palygink jų garsus ir nustatyk, ar žodžiai vienodi, ar skiriasi konkrečiu garsu. Atsakydamas nesiremk vien žodžio išvaizda – sutelk dėmesį į tai, ką girdi ir kaip garsai sudaro žodį.",
    benefits: [
      "lavina panašių garsų skyrimą",
      "stiprina fonologinį suvokimą",
      "lavina klausos dėmesį"
    ],
    suitableFor: "vaikams, lavinantiems foneminį suvokimą ir garsų skyrimą"
  },

  "kvepuojantis-drakonas": {
    intro: "Ramus dėmesio ir kvėpavimo pratimas, pateiktas žaismingos drakono istorijos forma.",
    mechanics: "Žaidime pateikiamos kelios kvėpavimo užduotys su istorija ir instrukcijomis.",
    howToPlay: "Perskaityk drakono instrukciją ir atlik pateiktą kvėpavimo pratimą pagal nurodymus.",
    benefits: [
      "lavina dėmesio koncentraciją",
      "moko sąmoningai atlikti kvėpavimo pratimus",
      "suteikia ramią žaidybinę veiklą"
    ],
    suitableFor: "vaikams, kuriems naudingi trumpi dėmesio ir kvėpavimo pratimai"
  },

  "skiemenu-plojimas": {
    intro: "Skiemenų Plojimas – žaismingas lietuvių kalbos žaidimas, padedantis vaikui išgirsti ir atpažinti žodžių skiemenis. Ritmiškas žodžio skaidymas leidžia lengviau suprasti jo struktūrą ir pastebėti, iš kiek dalių jis susideda. Tai gali būti naudingas žingsnis stiprinant ankstyvojo skaitymo ir kalbinio sąmoningumo įgūdžius.",
    mechanics: "Žaidime vaikas analizuoja pateiktus žodžius ir nustato jų skiemenų skaičių arba struktūrą. Plojimo principas padeda kiekvieną skiemenį susieti su atskiru ritminiu vienetu. Kartojant skirtingo ilgio žodžius lavinamas gebėjimas girdėti jų sandarą ir tiksliau skaidyti žodžius.",
    howToPlay: "Ištark pateiktą žodį lėtai ir atkreipk dėmesį į jo dalis. Kiekvienam skiemeniui skirk po vieną plojimą arba kitą aiškų ritminį veiksmą. Suskaičiuok skiemenis ir pasirink atsakymą, atitinkantį visą žodį.",
    benefits: [
      "lavina skiemenų atpažinimą",
      "stiprina fonologinį suvokimą",
      "lavina kalbinį ritmą"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams, besimokantiems skiemenuoti"
  },

  "garso-detektyvas": {
    intro: "Garso Detektyvas – logopedinis žaidimas, padedantis vaikui atpažinti, kurioje žodžio vietoje yra tam tikras kalbos garsas. Vaikas analizuoja žodžio garsinę struktūrą ir mokosi nustatyti garso vietą žodžio pradžioje, viduryje ar pabaigoje. Tokios užduotys padeda lavinti foneminį suvokimą ir dėmesį kalbos garsams.",
    mechanics: "Žaidime pateikiamas žodis ir konkretus garsas, kurio vietą reikia nustatyti. Vaikas analizuoja žodį ir sprendžia, kurioje jo dalyje girdimas nurodytas garsas. Užduotys skatina klausytis atidžiai, lyginti garsinę informaciją ir sąmoningai pastebėti žodžio sandarą.",
    howToPlay: "Ištark pateiktą žodį lėtai ir atkreipk dėmesį į nurodytą garsą. Pagalvok, ar jis girdimas žodžio pradžioje, viduryje, ar pabaigoje. Pasirink tinkamą garso vietą ir prieš patvirtindamas dar kartą ištark žodį. Kartojant skirtingus pavyzdžius stenkis vis greičiau atpažinti garso vietą.",
    benefits: [
      "lavina garso vietos atpažinimą",
      "stiprina fonologinį suvokimą",
      "lavina žodžio analizės įgūdžius"
    ],
    suitableFor: "vaikams, lavinantiems foneminį suvokimą ir kalbos garsų atpažinimą"
  },

  "zodziu-bingo": {
    intro: "Skaitymo Bingo žaidimas, kuriame vaikas atpažįsta pateiktus žodžius ir žymi juos Bingo lentelėje.",
    mechanics: "Žaidime pateikiama žodžių Bingo lentelė, kurioje reikia surasti iškviestą žodį.",
    howToPlay: "Perskaityk pateiktą žodį ir rask tokį patį žodį Bingo lentelėje.",
    benefits: [
      "lavina žodžių atpažinimą",
      "stiprina skaitymo įgūdžius",
      "lavina dėmesį"
    ],
    suitableFor: "pradedantiems skaityti vaikams"
  },

  "pasaku-kelione": {
    intro: "Skaitymo supratimo žaidimas, kuriame vaikas skaito pasakojimą ir atsako į klausimus.",
    mechanics: "Vaikas perskaito tekstą ir sprendžia pagal jį pateiktas teksto supratimo užduotis.",
    howToPlay: "Atidžiai perskaityk pasakojimą ir atsakyk į klausimus pagal perskaitytą tekstą.",
    benefits: [
      "lavina teksto supratimą",
      "stiprina skaitymo įgūdžius",
      "moko rasti informaciją tekste"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams"
  },

  "zodziu-medziokle": {
    intro: "Žodžių Medžioklė – skaitymo ir lietuvių kalbos žaidimas, kuriame vaikas tekste ieško konkrečių žodžių. Atidžiai skaitydamas ir ieškodamas nurodytų žodžių vaikas lavina žodžių atpažinimą, dėmesį ir gebėjimą greitai rasti informaciją tekste. Užduotis paprasta suprasti, tačiau skatina skaityti susikaupus.",
    mechanics: "Žaidime pateikiamas tekstas ir tikslinių žodžių sąrašas, kuriuos reikia surasti. Vaikas turi perskaityti arba peržvelgti tekstą, atpažinti ieškomus žodžius ir juos pasirinkti. Kartojant užduotis lavinamas gebėjimas vizualiai atpažinti žodžius bei kryptingai ieškoti konkrečios informacijos.",
    howToPlay: "Pirmiausia perskaityk pateiktą tekstą ir įsidėmėk, kokių žodžių reikia ieškoti. Tada nuosekliai peržvelk tekstą ir rask kiekvieną nurodytą žodį. Patikrink, ar pasirinkai būtent tą žodį, kuris pateiktas užduotyje. Stenkis nepraleisti panašiai atrodančių žodžių ir atsakymą patvirtink tik įsitikinęs.",
    benefits: [
      "lavina skaitymo dėmesį",
      "stiprina žodžių atpažinimą",
      "moko ieškoti konkrečios informacijos tekste"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams, lavinantiems žodžių atpažinimą ir skaitymą"
  },

  "veikeju-detektyvas": {
    intro: "Veikėjų Detektyvas – skaitymo ir teksto supratimo žaidimas, kuriame vaikas analizuoja pasakojimo veikėjus ir jų vaidmenį istorijoje. Užduotys padeda atkreipti dėmesį į tai, kas vyksta su veikėjais, kokie jų bruožai ir kaip jie susiję su pasakojimo įvykiais. Tai lavina gebėjimą informaciją rasti ir suprasti tekste.",
    mechanics: "Vaikas skaito arba analizuoja pateiktą pasakojimo informaciją ir turi nustatyti, kuris veikėjas atitinka užduoties sąlygą. Gali reikėti atpažinti veikėjo savybę, veiksmą, santykį su kitu veikėju arba vaidmenį istorijoje. Tokia analizė skatina skaityti atidžiau ir remtis konkrečia teksto informacija.",
    howToPlay: "Perskaityk pasakojimą ir atkreipk dėmesį į veikėjų veiksmus bei savybes. Perskaityk klausimą ir grįžk prie teksto, jei reikia patikrinti informaciją. Pasirink atsakymą, kurį gali pagrįsti konkrečiais pasakojimo faktais.",
    benefits: [
      "lavina teksto supratimą",
      "moko daryti išvadas iš teksto",
      "stiprina informacijos analizę"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, lavinantiems teksto supratimą ir veikėjų analizę"
  },

  "skyrybos-policija": {
    intro: "Skyrybos Policija – lietuvių kalbos žaidimas, kuriame vaikas tampa sakinių „detektyvu“ ir mokosi pastebėti skyrybos klaidas. Užduotys padeda suprasti, kad kableliai, taškai, klaustukai ir kiti skyrybos ženklai padeda aiškiai perteikti sakinio prasmę. Žaidžiant lavinamas atidumas ir praktinis skyrybos taisyklių taikymas.",
    mechanics: "Vaikui pateikiami sakiniai, kuriuose reikia rasti vietą, kur trūksta skyrybos ženklo arba pasirinkti tinkamą jo variantą. Analizuodamas sakinį vaikas mokosi atkreipti dėmesį į jo struktūrą, intonaciją ir prasmę. Tokia praktika padeda taisykles taikyti konkrečiame kalbos kontekste.",
    howToPlay: "Perskaityk sakinį nuo pradžios iki galo ir atkreipk dėmesį į jo prasmę. Rask vietą, kurioje reikalingas skyrybos ženklas, ir pasirink arba pataisyk tinkamą variantą. Prieš patvirtindamas atsakymą dar kartą perskaityk visą sakinį ir patikrink, ar jis skamba taisyklingai.",
    benefits: [
      "lavina skyrybos įgūdžius",
      "stiprina sakinio analizę",
      "moko pastebėti kalbos klaidas"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems lietuvių kalbos skyrybos"
  },

  "greito-skaitymo-lenktynes": {
    intro: "Greito Skaitymo Lenktynės – skaitymo žaidimas, padedantis vaikui lavinti skaitymo sklandumą ir gebėjimą suprasti perskaitytą tekstą. Vaikas skaito pateiktą tekstą, stebi savo skaitymo tempą ir atlieka su tekstu susijusią užduotį. Žaidybinis formatas skatina skaityti atidžiai ir kartu siekti geresnio rezultato.",
    mechanics: "Žaidime pateikiamas tekstas, kurį vaikas turi perskaityti ir suprasti. Skaitymo metu fiksuojamas tempas, o po skaitymo pateikiama užduotis, leidžianti patikrinti, ar tekstas buvo suprastas. Taip vaikas mokosi derinti skaitymo greitį su tikslumu ir teksto suvokimu.",
    howToPlay: "Perskaityk pateiktą tekstą nuo pradžios iki pabaigos ir stenkis išlaikyti tolygų tempą. Baigęs skaityti atlik pateiktą teksto supratimo užduotį. Atsakydamas remkis tuo, ką perskaitei, o ne vien bandyk spėti atsakymą. Kartodamas užduotis stebėk, kaip keičiasi tavo skaitymo tempas ir tikslumas.",
    benefits: [
      "lavina skaitymo tempą",
      "stiprina teksto supratimą",
      "skatina skaityti atidžiai"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, lavinantiems skaitymo sklandumą ir teksto supratimą"
  },

  "pasaku-matematika": {
    intro: "Pasakų Matematika – matematikos žaidimas, kuriame skaičiavimo užduotys pateikiamos per pasakų ir istorijų kontekstą. Vaikas sprendžia matematines situacijas, susijusias su veikėjais, daiktais ar įvykiais, todėl skaičiavimas tampa labiau susietas su prasmingu pasakojimu. Tai padeda praktikuoti matematinius veiksmus žaismingu būdu.",
    mechanics: "Žaidime pateikiamos trumpos istorijos su matematine užduotimi. Vaikas turi suprasti situaciją, išskirti reikalingus skaičius ir pasirinkti tinkamą veiksmą. Spręsdamas užduotį jis kartu lavina teksto supratimą ir gebėjimą matematinę informaciją panaudoti praktiniame kontekste.",
    howToPlay: "Perskaityk pasakos situaciją ir išsiaiškink, kokie skaičiai svarbūs užduočiai. Pagal klausimą pasirink sudėties, atimties ar kitą reikalingą veiksmą. Apskaičiuok rezultatą ir patikrink, ar jis logiškai atitinka istorijoje aprašytą situaciją.",
    benefits: [
      "lavina tekstinių uždavinių sprendimą",
      "stiprina matematinį mąstymą",
      "moko matematiką taikyti situacijose"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, norintiems matematikos veiksmus mokytis per istorijas"
  },

  "zodziu-ir-skaiciu-galvosukis": {
    intro: "Žodžių ir Skaičių Galvosūkis – mišrus mokomasis žaidimas, kuriame vaikas sprendžia užduotis, susijusias su žodžiais, skaičiais ir jų tarpusavio ryšiais. Skirtingų tipų informacijos derinimas skatina lankstų mąstymą ir gebėjimą vienoje užduotyje taikyti kelis įgūdžius. Žaidimo formatas padeda mokymąsi paversti galvosūkiu.",
    mechanics: "Žaidime gali būti pateikiami žodžiai, skaičiai arba jų kombinacijos, kurias reikia palyginti, susieti ar panaudoti sprendžiant galvosūkį. Vaikas analizuoja užduoties sąlygą, atrenka svarbiausią informaciją ir ieško tinkamo atsakymo. Tokia veikla lavina dėmesį, logiką ir gebėjimą susieti skirtingo pobūdžio informaciją.",
    howToPlay: "Atidžiai perskaityk visą užduotį ir nustatyk, kokios informacijos reikia atsakymui. Atskirai įvertink žodžius ir skaičius, tada ieškok tarp jų pateikto ryšio. Pasirink atsakymą ir prieš patvirtindamas patikrink, ar jis atitinka visas galvosūkio sąlygas.",
    benefits: [
      "lavina loginį mąstymą",
      "stiprina problemų sprendimą",
      "lavina kalbos ir matematikos sąsajų suvokimą"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, lavinantiems loginį mąstymą, dėmesį ir kalbinius bei matematinius įgūdžius"
  },

  "ai-pasaku-rasytojas": {
    intro: "Kūrybinio rašymo žaidimas, kuriame vaikas kartu su AI kuria savo pasakojimą.",
    mechanics: "Vaikas rašo istorijos dalis, o žaidimas leidžia palaipsniui kurti bendrą pasakojimą.",
    howToPlay: "Pradėk rašyti pirmąją istorijos dalį ir tęsk pasakojimą kurdamas naujus sakinius.",
    benefits: [
      "lavina kūrybinį rašymą",
      "skatina vaizduotę",
      "plečia kalbinę raišką"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams"
  },

  "matematikos-meno-kurejas": {
    intro: "Kūrybinis matematikos žaidimas, kuriame matematinės užduotys susiejamos su skaitmeniniu piešimu.",
    mechanics: "Vaikas sprendžia matematines užduotis ir pagal jas kuria vaizdą skaitmeninėje drobėje.",
    howToPlay: "Išspręsk pateiktą matematikos užduotį ir naudok gautą informaciją kūrybinei užduočiai atlikti.",
    benefits: [
      "lavina matematinį mąstymą",
      "skatina kūrybiškumą",
      "susieja matematiką su praktine kūrybine veikla"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams"
  },

  "virtuali-mokslo-laboratorija": {
    intro: "Virtuali Mokslo Laboratorija – gamtos mokslų žaidimas, kuriame vaikas gali tyrinėti įvairias mokslines situacijas ir spręsti su eksperimentais susijusias užduotis. Žaidimas skatina smalsumą, priežasties ir pasekmės supratimą bei gebėjimą ieškoti atsakymo remiantis pateikta informacija. Mokslinės temos pateikiamos vaikui suprantamu žaidybiniu formatu.",
    mechanics: "Žaidime pateikiami tyrimų klausimai, eksperimentų situacijos ir pasirinkimai, kuriuos vaikas turi išanalizuoti. Spręsdamas užduotis jis mokosi stebėti požymius, lyginti galimus paaiškinimus ir pasirinkti atsakymą, geriausiai atitinkantį pateiktus duomenis. Tokia mechanika lavina mokslinį mąstymą ir problemų sprendimą.",
    howToPlay: "Perskaityk tyrimo klausimą ir atidžiai išanalizuok pateiktą situaciją. Pagal informaciją apsvarstyk galimus atsakymus ir pasirink tą, kuris logiškai paaiškina stebimą reiškinį. Jei reikia, grįžk prie pateiktų faktų ir patikrink, ar tavo pasirinkimas jais pagrįstas.",
    benefits: [
      "skatina domėjimąsi gamtos mokslais",
      "lavina tyrinėjimo mąstymą",
      "moko analizuoti informaciją"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besidomintiems gamtos mokslais ir eksperimentais"
  },

  "emociju-charados": {
    intro: "Žaidimas apie emocijas, kuriame vaikas mokosi atpažinti ir suprasti skirtingus jausmus.",
    mechanics: "Pateikiamos istorijos ir emocijų sekos, kurias vaikas turi atpažinti bei susieti su situacija.",
    howToPlay: "Perskaityk herojaus istoriją ir pasirink emocijų seką, kuri geriausiai atitinka situaciją.",
    benefits: [
      "lavina emocijų atpažinimą",
      "stiprina empatiją",
      "moko susieti emocijas su situacijomis"
    ],
    suitableFor: "vaikams, mokantiems pažinti ir įvardyti emocijas"
  },

  "receptu-matematikos-sefas": {
    intro: "Receptų Matematikos Šefas – praktinės matematikos žaidimas, kuriame skaičiavimas susiejamas su maisto gaminimo ir receptų situacijomis. Vaikas mokosi atlikti matematinius veiksmus naudodamas kiekius, porcijas ir ingredientų skaičiavimą. Kasdienis kontekstas padeda suprasti, kur matematika praverčia realiame gyvenime.",
    mechanics: "Žaidime pateikiamas receptas arba maisto gaminimo situacija, kurioje reikia apskaičiuoti ingredientų kiekius ar kitą matematinę reikšmę. Vaikas analizuoja pateiktus skaičius ir pritaiko tinkamą veiksmą. Tokios užduotys lavina skaičiavimo įgūdžius ir gebėjimą matematiką taikyti praktiškai.",
    howToPlay: "Perskaityk receptą ir išsiaiškink, kokius kiekius reikia apskaičiuoti. Nustatyk, kokį matematinį veiksmą reikia atlikti, apskaičiuok rezultatą ir pasirink tinkamą atsakymą. Prieš patvirtindamas patikrink, ar rezultatas atitinka pateiktą recepto situaciją.",
    benefits: [
      "lavina praktinį skaičiavimą",
      "moko taikyti matematiką kasdienybėje",
      "stiprina proporcijų supratimą"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems praktiškai taikyti matematiką"
  },

  "geografijos-lobiu-medziokle": {
    intro: "Geografijos žaidimas, kuriame vaikas pagal užuominas ieško tinkamų vietovių.",
    mechanics: "Žaidime pateikiamos geografijos užuominos, o vaikas turi pasirinkti tinkamą vietovę.",
    howToPlay: "Perskaityk ekspedicijos užuominą, išanalizuok ją ir pasirink vietovę, kuri geriausiai ją atitinka.",
    benefits: [
      "lavina geografines žinias",
      "stiprina orientavimąsi vietovių informacijoje",
      "moko analizuoti geografines užuominas"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams"
  },

  "gyvunu-buveines": {
    intro: "Gyvūnų Buveinės – gamtos pažinimo žaidimas, kuriame vaikas mokosi susieti gyvūnus su jų natūraliomis gyvenamosiomis aplinkomis. Lygindamas skirtingus gyvūnus ir buveines vaikas mokosi klasifikuoti informaciją bei pastebėti, kur tam tikros rūšys gyvena. Žaidybinis formatas padeda gamtos mokslų žinias susieti su konkrečiais pavyzdžiais.",
    mechanics: "Žaidime vaikas turi suderinti pateiktą gyvūną su tinkama jo gyvenamąja aplinka. Užduotis reikalauja atpažinti gyvūną, prisiminti jo gyvenimo sąlygas ir pasirinkti atitinkamą buveinę. Kartojant skirtingus pavyzdžius stiprinamas supratimas apie gyvūnų įvairovę ir jų prisitaikymą prie aplinkos.",
    howToPlay: "Pasirink pateiktą gyvūną ir peržiūrėk galimas jo buveines. Pagalvok, kokioje aplinkoje šis gyvūnas natūraliai gyvena ir kokios sąlygos jam tinkamos. Pasirink atitinkamą buveinę ir prieš patvirtindamas patikrink, ar ji logiškai dera su gyvūnu. Kartodamas užduotis mokykis atpažinti skirtingas buveines.",
    benefits: [
      "moko apie gyvūnų buveines",
      "lavina gamtos pažinimą",
      "stiprina klasifikavimo įgūdžius"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams, besimokantiems apie gyvūnus ir jų buveines"
  },

  "oru-stotis": {
    intro: "Orų Stotis – gamtos mokslų žaidimas, kuriame vaikas analizuoja atmosferos požymius ir mokosi suprasti, kaip jie susiję su orais. Vaikas stebi pateiktus oro scenarijus, vertina skirtingus požymius ir bando numatyti tinkamą orų situaciją. Žaidimas padeda gamtos pažinimą susieti su kasdien aplink mus stebimais reiškiniais.",
    mechanics: "Žaidime pateikiami oro scenarijai ir atmosferos požymiai, pagal kuriuos vaikas turi nustatyti tinkamą orų situaciją. Spręsdamas užduotis vaikas analizuoja informaciją, lygina požymius ir ieško jų tarpusavio ryšio. Taip praktiškai mokomasi atpažinti skirtingus orų požymius ir juos interpretuoti.",
    howToPlay: "Perskaityk pateiktą oro situaciją ir atidžiai peržiūrėk nurodytus atmosferos požymius. Pagal juos pagalvok, kokie orai labiausiai tikėtini. Palygink galimus atsakymus ir pasirink tą, kuris geriausiai atitinka visą pateiktą informaciją. Prieš patvirtindamas dar kartą patikrink savo išvadą.",
    benefits: [
      "moko pažinti orų reiškinius",
      "lavina priežasties ir pasekmės suvokimą",
      "skatina gamtos reiškinių analizę"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams, besidomintiems orais ir gamtos pažinimu"
  },

  "ritmo-kurejas": {
    intro: "Muzikinis žaidimas, kuriame vaikas klausosi ir atkartoja pateiktus ritmus.",
    mechanics: "Žaidime pateikiami skirtingi ritminiai raštai, kuriuos vaikas turi atpažinti ir atkartoti.",
    howToPlay: "Paliesk būgną, išgirsk ritmą ir pabandyk jį atkartoti tinkama seka.",
    benefits: [
      "lavina ritminę klausą",
      "stiprina dėmesį",
      "lavina muzikinę atmintį"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams"
  },

  "natu-pavadinimai": {
    intro: "Muzikos pagrindų žaidimas, kuriame vaikas mokosi atpažinti natas penklinėje.",
    mechanics: "Žaidime rodoma nata penklinėje, o vaikas turi pasirinkti jos pavadinimą.",
    howToPlay: "Peržiūrėk natos vietą penklinėje ir pasirink jos pavadinimą.",
    benefits: [
      "moko natų pavadinimų",
      "lavina muzikinę atmintį",
      "stiprina muzikos rašto pažinimą"
    ],
    suitableFor: "vaikams, besimokantiems muzikos pagrindų"
  },

  "simonas-sako": {
    intro: "Klausymo ir dėmesio žaidimas pagal klasikinę „Simonas sako“ žaidimo taisyklę.",
    mechanics: "Vaikas turi atlikti veiksmą tik tada, kai instrukcija prasideda žodžiais „Simonas sako“.",
    howToPlay: "Atidžiai klausykis kiekvienos instrukcijos. Jei Simonas pasakė – atlik veiksmą, jei ne – lauk.",
    benefits: [
      "lavina klausos dėmesį",
      "stiprina instrukcijų supratimą",
      "lavina impulsų kontrolę"
    ],
    suitableFor: "ikimokyklinio ir pradinio mokyklinio amžiaus vaikams"
  },

  "figuru-joga": {
    intro: "Žaismingas judesio ir dėmesio žaidimas, kuriame geometrinės figūros susiejamos su pozomis.",
    mechanics: "Vaikas seka pateiktą pozą, išlaiko ją ir pereina prie kito žaidimo etapo.",
    howToPlay: "Peržiūrėk pozos pavadinimą ir instrukciją, atlik pozą bei kurį laiką joje išbūk nejudėdamas.",
    benefits: [
      "skatina judėjimą",
      "lavina dėmesio koncentraciją",
      "moko sekti instrukcijas"
    ],
    suitableFor: "vaikams, kuriems patinka judesio žaidimai"
  },

  "veterinarijos-klinika": {
    intro: "Problemas sprendžiantis žaidimas, kuriame vaikas tampa veterinarijos klinikos gydytoju.",
    mechanics: "Žaidime pateikiami gyvūnų pacientų atvejai, simptomai ir galimos diagnozės.",
    howToPlay: "Išanalizuok gyvūno simptomus, pasirink diagnozę ir atlik pateiktą gydymo užduotį.",
    benefits: [
      "lavina problemų sprendimą",
      "skatina domėjimąsi gyvūnais",
      "moko analizuoti požymius ir daryti išvadas"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams"
  },

  "parduotuves-kasininkas": {
    intro: "Parduotuvės Kasininkas – praktinės matematikos žaidimas, kuriame vaikas sprendžia pirkimo situacijas ir mokosi taikyti skaičiavimą kasdieniame kontekste. Dirbdamas su prekių kainomis vaikas praktikuoja matematinius veiksmus ir mokosi suprasti pinigų bei pirkimo situacijas. Tai padeda parodyti, kaip matematika praverčia realiame gyvenime.",
    mechanics: "Žaidime pateikiamos parduotuvės situacijos, kuriose reikia dirbti su prekių kainomis ir apskaičiuoti pirkimo rezultatą. Vaikas analizuoja pateiktus skaičius ir atlieka reikalingus matematinius veiksmus. Tokios užduotys leidžia skaičiavimą susieti su pažįstama situacija ir kartu lavina praktinį problemų sprendimą.",
    howToPlay: "Peržiūrėk prekes ir jų kainas bei atidžiai perskaityk užduoties sąlygą. Nustatyk, kokį matematinį veiksmą reikia atlikti, apskaičiuok rezultatą ir pasirink tinkamą atsakymą. Prieš patvirtindamas patikrink, ar apskaičiuota suma atitinka pateiktą pirkimo situaciją.",
    benefits: [
      "lavina pinigų skaičiavimą",
      "stiprina praktinę matematiką",
      "moko matematiką taikyti kasdienėje situacijoje"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, besimokantiems praktiškai taikyti matematiką ir skaičiavimą"
  },

  "mokytojo-padejejas": {
    intro: "Loginio mąstymo žaidimas, kuriame vaikas sprendžia mokyklines užduotis ir rūšiuoja informaciją.",
    mechanics: "Žaidime pateikiamos įvairios užduotys, įskaitant elementų dėliojimą abėcėlės tvarka.",
    howToPlay: "Perskaityk užduotį, išanalizuok pateiktus elementus ir sudėliok juos reikiama tvarka.",
    benefits: [
      "lavina loginį mąstymą",
      "stiprina informacijos rūšiavimo įgūdžius",
      "moko nuosekliai atlikti užduotis"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams"
  },

  "laiko-kelione-per-istorija": {
    intro: "Istorijos žaidimas, kuriame vaikas keliauja per skirtingas istorines epochas.",
    mechanics: "Žaidime pateikiamos istorinės epochos, datos, įvykiai ir klausimai, kuriuos reikia susieti.",
    howToPlay: "Peržiūrėk pateiktą epochą, metus ir istorinį įvykį, tada pasirink tinkamą atsakymą.",
    benefits: [
      "lavina istorijos žinias",
      "padeda suprasti chronologiją",
      "stiprina istorinių įvykių susiejimą"
    ],
    suitableFor: "pradinio ir pagrindinio mokyklinio amžiaus vaikams"
  },

  "ai-programavimo-blokai": {
    intro: "Žaismingas programavimo pagrindų žaidimas, kuriame vaikas kuria komandų sekas.",
    mechanics: "Vaikas dėlioja programavimo komandas į seką, kad pasiektų pateiktą tikslą.",
    howToPlay: "Peržiūrėk užduotį, pasirink reikalingas komandas ir sudėliok jas tinkama vykdymo tvarka.",
    benefits: [
      "lavina algoritminį mąstymą",
      "moko komandų sekų",
      "stiprina problemų sprendimą"
    ],
    suitableFor: "vaikams, besidomintiems programavimo pagrindais"
  },

  "svajoniu-kurejas": {
    intro: "Kūrybinis žaidimas, kuriame vaikas kuria savo svajonių pasaulį pasirinkdamas skirtingus istorijos elementus.",
    mechanics: "Žaidimas pateikia istorijos etapus ir pasirinkimus, iš kurių vaikas kuria individualų pasakojimą.",
    howToPlay: "Perskaityk istorijos etapą ir pasirink elementus, kurie taps tavo kuriamo pasaulio dalimi.",
    benefits: [
      "skatina vaizduotę",
      "lavina kūrybiškumą",
      "moko priimti sprendimus istorijos kūrimo metu"
    ],
    suitableFor: "vaikams, mėgstantiems kūrybines užduotis"
  },

  "paslapciu-matematikos-detektyvas": {
    intro: "Paslapčių Matematikos Detektyvas – matematikos žaidimas, kuriame vaikas sprendžia užduotis ir renka įkalčius, padedančius atskleisti paslaptį. Matematiniai veiksmai pateikiami kaip detektyvinė užduotis, todėl vaikas turi ne tik apskaičiuoti rezultatą, bet ir suprasti, kokios informacijos reikia sprendimui. Tai skatina loginį ir nuoseklų problemų sprendimą.",
    mechanics: "Žaidime pateikiamos matematinės užduotys, kurių sprendimai susiejami su detektyviniais įkalčiais. Vaikas analizuoja sąlygą, atlieka reikalingus skaičiavimus ir pagal gautą rezultatą gauna informaciją tolesniam sprendimui. Tokia struktūra leidžia matematiką praktikuoti kaip kelių žingsnių problemų sprendimo procesą.",
    howToPlay: "Atidžiai perskaityk matematinę užduotį ir išsiaiškink, kokių skaičių bei veiksmų reikia. Išspręsk užduotį ir įvertink gautą rezultatą. Naudok gautą įkalčio informaciją kitam žingsniui ir nuosekliai tikrink savo sprendimus. Kuo atidžiau analizuoji sąlygą, tuo lengviau atskleisi visą matematinę paslaptį.",
    benefits: [
      "lavina matematinį problemų sprendimą",
      "stiprina loginį mąstymą",
      "skatina nuosekliai analizuoti informaciją"
    ],
    suitableFor: "pradinio mokyklinio amžiaus vaikams, lavinantiems matematinį ir loginį problemų sprendimą"
  },

  "debatu-arena": {
    intro: "Kalbos ir argumentavimo žaidimas, kuriame vaikas mokosi formuluoti argumentus ir vertinti skirtingas nuomones.",
    mechanics: "Žaidime pateikiama diskusijos tema ir skirtingos argumentų pozicijos.",
    howToPlay: "Perskaityk debatų temą, išanalizuok argumentus ir pasirink arba suformuluok pagrįstą poziciją.",
    benefits: [
      "lavina argumentavimą",
      "stiprina kalbos raišką",
      "moko vertinti skirtingus požiūrius"
    ],
    suitableFor: "pradinio ir pagrindinio mokyklinio amžiaus vaikams"
  },

  "kuciu-stalas": {
    intro: "Kultūrinis edukacinis žaidimas apie Kūčių stalą, tradicijas ir lietuviškus patiekalus.",
    mechanics: "Vaikas susipažįsta su Kūčių stalo elementais, patiekalais ir jų tradicine reikšme.",
    howToPlay: "Peržiūrėk pateiktus patiekalus ir stalo elementus, sužinok jų reikšmę ir tinkamai sudėliok šventinį stalą.",
    benefits: [
      "supažindina su lietuviškomis tradicijomis",
      "skatina domėjimąsi kultūra",
      "padeda pažinti Kūčių stalo papročius"
    ],
    suitableFor: "vaikams, besidomintiems Lietuvos kultūra ir tradicijomis"
  }
};

export function getSEOGameDetails(slug) {
  return SEO_GAME_DETAILS[slug] || null;
}
